import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'

import SearchReducer, { NAME as SearchReducerName } from './search/reducer'
import MapReducer, { NAME as MapReducerName } from './map/reducer'

export default function configureStore(initialState) {
  const reducers = {
    [SearchReducerName]: SearchReducer,
    [MapReducerName]: MapReducer,
  }

  const middleware = [thunk]

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = []
  const isDevelopment = process.env.NODE_ENV === 'development'
  if (
    isDevelopment &&
    typeof window !== 'undefined' &&
    window.devToolsExtension
  ) {
    enhancers.push(window.devToolsExtension())
  }

  const rootReducer = combineReducers({
    ...reducers,
  })

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  )
}
